import React from 'react';
import { Box, Skeleton } from '@mui/material';

const PageTitleSkeleton = ({ count = 2 }) => {
  return (
    <Box px={2} py={1} width={'100%'}>
      <Box display='flex' alignItems='center' gap={1.5}>
        {Array.from({ length: count }).map((__, idx) => {
          return (
            <React.Fragment key={idx}>
              <Skeleton variant='text' width={idx % 2 === 0 ? 50 : 90} height={28} />
              {idx !== count - 1 && <span>|</span>}
            </React.Fragment>
          );
        })}
      </Box>
    </Box>
  );
};
export default PageTitleSkeleton;
